import * as React from 'react';
import * as mui from '@mui/material';

import typography from './typography';
import getComponents from './components';

interface AppThemeProviderProps {
	children: React.ReactNode;
}

const AppThemeProvider = (props: AppThemeProviderProps) => {
	const theme = React.useMemo(() => {
		const theme = mui.createTheme({
			palette: {
				mode: 'light',
				common: {
					black: '#ff0000',
				},
				primary: {
					main: '#53ABAA',
				},
				secondary: {
					main: '#ffffff',
				},
			},
			typography,
			shape: {
				borderRadius: 15,
			},
		});

		theme.components = getComponents(theme);

		return theme;
	}, []);

	return (
		<mui.ThemeProvider theme={theme}>
			<mui.CssBaseline />
			{props.children}
		</mui.ThemeProvider>
	);
};

export default AppThemeProvider;
